<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select v-model="listQuery.tenantId" placeholder="请选择租户" style="width: 200px;" class="filter-item" clearable>
        <el-option v-for="item in tenantList" :key="item.tenantId" :label="item.name" :value="item.tenantId" />
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="getList">查询</el-button>
      <el-button class="filter-item" style="margin-left: 10px;" type="success" icon="el-icon-plus" @click="handleCreate">新增</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="ID" prop="departmentId" align="center" width="80" />
      <el-table-column label="租户" prop="tenantName" align="center" width="150" />
      <el-table-column label="部门名称" prop="name" align="center" />
      <el-table-column label="描述" prop="description" align="center" show-overflow-tooltip />
      <el-table-column label="优先级" prop="priority" align="center" width="100" />
      <el-table-column label="状态" prop="isActive" align="center" width="100">
        <template slot-scope="{row}">
          <el-tag :type="row.isActive ? 'success' : 'info'">{{ row.isActive ? '启用' : '禁用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createdAt" align="center" width="160">
        <template slot-scope="{row}">
          <span>{{ row.createdAt | parseTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="{row}">
          <el-button type="primary" size="mini" @click="handleUpdate(row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList" />

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="100px" style="width: 400px; margin-left:50px;">
        <el-form-item label="所属租户" prop="tenantId">
          <el-select v-model="temp.tenantId" placeholder="请选择租户" style="width: 100%;">
            <el-option v-for="item in tenantList" :key="item.tenantId" :label="item.name" :value="item.tenantId" />
          </el-select>
        </el-form-item>
        <el-form-item label="部门名称" prop="name">
          <el-input v-model="temp.name" />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="temp.description" type="textarea" />
        </el-form-item>
        <el-form-item label="优先级" prop="priority">
          <el-input-number v-model="temp.priority" :min="0" />
        </el-form-item>
        <el-form-item label="状态" prop="isActive">
          <el-switch v-model="temp.isActive" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listDepartments, createDepartment, updateDepartment, deleteDepartment } from '@/api/department'
import { listTenants } from '@/api/tenant'
import Pagination from '@/components/Pagination'

export default {
  name: 'DepartmentList',
  components: { Pagination },
  filters: {
    parseTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return date.toLocaleString()
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        tenantId: undefined
      },
      tenantList: [],
      temp: {},
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      rules: {
        tenantId: [{ required: true, message: '请选择租户', trigger: 'change' }],
        name: [{ required: true, message: '请输入部门名称', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getTenantList()
    this.getList()
  },
  methods: {
    getTenantList() {
      listTenants({ pageNum: 1, pageSize: 1000 }).then(response => {
        this.tenantList = response.data.records || []
      })
    },
    getList() {
      this.listLoading = true
      listDepartments(this.listQuery).then(response => {
        this.list = response.data || []
        this.total = this.list.length
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    resetTemp() {
      this.temp = {
        tenantId: this.listQuery.tenantId,
        name: '',
        description: '',
        priority: 0,
        isActive: true
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          createDepartment(this.temp).then(() => {
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          })
        }
      })
    },
    handleUpdate(row) {
      this.temp = {
        departmentId: row.departmentId,
        tenantId: row.tenantId,
        name: row.name,
        description: row.description,
        priority: row.priority,
        isActive: row.isActive
      }
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const data = {
            name: this.temp.name,
            description: this.temp.description,
            priority: this.temp.priority,
            isActive: this.temp.isActive
          }
          updateDepartment(this.temp.departmentId, data).then(() => {
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该部门吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDepartment(row.departmentId).then(() => {
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
          this.getList()
        })
      })
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.filter-item {
  margin-right: 10px;
}
</style>
